import type {
  IGoodsListGetGoodsV2Request,
  IGoodsListGetGoodsV2Response,
  IGoodsListAddGoodsRequest,
  IGoodsListRemoveGoodsRequest,
} from './models';

import { MMGatewayClient } from '../MMGatewayClient';

/** если появятся списки помимо "Избранного" - нужно будет захойстить */
const FAVORITES_CATALOG_TYPE = '4';
const GOODS_PER_PAGE = 20;

class _GoodsListClient extends MMGatewayClient {
  public async getGoodsList(page: number): Promise<IGoodsListGetGoodsV2Response> {
    return this.post<IGoodsListGetGoodsV2Response, IGoodsListGetGoodsV2Request>(
      'api/v2/goods/get',
      {
        catalogType: FAVORITES_CATALOG_TYPE,
        pagination: {
          limit: GOODS_PER_PAGE,
          offset: (page - 1) * GOODS_PER_PAGE,
        },
      }
    );
  }

  public async addToGoodsList(productId: string): Promise<any> {
    return this.post<any, IGoodsListAddGoodsRequest>('api/v1/goods/add', {
      catalogType: FAVORITES_CATALOG_TYPE,
      items: [{ goodId: productId }],
    });
  }

  public async removeFromGoodsList(productId: string): Promise<any> {
    return this.post<any, IGoodsListRemoveGoodsRequest>('api/v1/goods/delete', {
      catalogType: FAVORITES_CATALOG_TYPE,
      items: [{ goodId: productId }],
    });
  }

  public async syncFavorites(): Promise<any> {
    return this.post('market/v2/favorites/sync');
  }
}

export const GoodsListClient = new _GoodsListClient();
